import type { PaymentStatusChangesResponse } from "@/types/api/payment-status";

const PAYMENT_STATUS_URL =
	"https://group-dev.pay.accessacloud.com/paylinks-payment-test/api/v1/paymentlinks/status-changes";

const PAYMENT_STATUS_HEADERS: Record<string, string> = {
	"x-api-key": "f478b32ce324432d9c96f71620481176",
	divisionaccountId: "b2a62d77-74bf-4eff-9003-29c91462b6a6",
	merchantId: "2915a06a-a494-435a-b430-0755cbb86807",
};

export async function getPaymentStatusChanges(
	signal?: AbortSignal,
): Promise<PaymentStatusChangesResponse> {
	const response = await fetch(PAYMENT_STATUS_URL, {
		method: "GET",
		headers: PAYMENT_STATUS_HEADERS,
		signal,
	});

	if (!response.ok) {
		throw new Error(`Payment status API error: ${response.status}`);
	}

	return response.json();
}
